<template>
  <div ref="codeWindow" style="width: 100%; height: 400px"></div>
</template>

<script>
import loader from "@monaco-editor/loader"; // --- solve loader problem with "monaco-editor": "^0.31.1"
//import * as monaco from 'monaco-editor/esm/vs/editor/editor.api'; --- few libraries but intellisense disabled :( )
import { ref, onMounted } from 'vue'

export default {
  props: {
    code: String,
    language: String,
    readOnly: Boolean,
  },

  setup(props) {
    const codeWindow = ref(null);
    let editor = null;

    onMounted(async () => {
      const monaco = await loader.init();
      const editorOptions = {
        value: props.code,
        language: props.language,
        readOnly: props.readOnly??false,
        theme: "vs-dark",
        minimap: { enabled: false },
      };
      editor = monaco.editor.create(codeWindow.value, editorOptions);
    })
    const getContent = () => editor.getValue();
    const setContent = (code) => editor.setValue(code);
    const updateOptions = (options) => editor.updateOptions(options);
    
    return {
      getContent,
      setContent,
      codeWindow,
      updateOptions,
    }
  }
};
</script>